module.exports = __webpack_public_path__ + "static/img/home-group2.242ef104.png";